import { Loader } from "lucide-react";
import React from "react";

export default function Button({
  children,
  lg,
  disabled,
  filled,
  color,
  loading,
  onClick = () => {},
  classes = {},
}) {
  return (
    <button
      className={`${classes} docpro_bordered_btn docpro_fw_600 ${
        filled ? "docpro_filed_btn" : ""
      } ${color ? `docpro_btn_${color}` : ""} ${
        disabled ? "docpro_disabled" : ""
      } ${lg ? "size_lg" : ""}`}
      style={{ pointerEvents: `${loading ? "none" : "initial"}` }}
      onClick={onClick}
    >
      {children}
      {loading && (
        <span className="docpro_loading">
          <Loader width={20} height={20} />
        </span>
      )}
    </button>
  );
}
